import React, { useState } from "react";
import HeroBackground from "./hero/HeroBackground";
import HeroContent from "./hero/HeroContent";
import VehicleAnimation from "./hero/VehicleAnimation";
import VideoPlayer from "@/components/support/VideoPlayer";
import ScrollIndicator from "./hero/ScrollIndicator";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";
import { HOW_IT_WORKS_HERO_VIDEO_URL } from "@/config/constants";

const HowItWorksHero = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const videoModalTitle =
    labels.menuPages?.howItWorks?.hero?.videoModalTitle ??
    "Hur BILENIA fungerar";

  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const scrollToContent = () => {
    const contentSection = document.getElementById("how-content");
    if (contentSection) {
      contentSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="relative min-h-screen overflow-hidden"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <HeroBackground isHovering={isHovering} />

      <div className="relative z-10 container mx-auto px-4 py-12 md:py-20 flex items-center justify-center min-h-screen">
        <div className="w-full max-w-6xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-0 min-w-0">
          <HeroContent />
          <div className="w-full lg:w-auto flex justify-center lg:block flex-shrink-0">
            <VehicleAnimation onVideoOpen={() => setShowVideoPlayer(true)} />
          </div>
        </div>
      </div>

      <ScrollIndicator onScrollToContent={scrollToContent} />
      {showVideoPlayer && (
        <VideoPlayer
          videoUrl={HOW_IT_WORKS_HERO_VIDEO_URL}
          title={videoModalTitle}
          onClose={() => setShowVideoPlayer(false)}
          defaultPlaybackRate={0.75}
        />
      )}
    </section>
  );
};

export default HowItWorksHero;
